// Hero Mobile Mega Menu
// Note: This file requires menu data (megaMenu, secondMenu, sidebarMenu) to be defined globally
// These are defined in hero-slider.liquid as they contain Liquid template variables

document.addEventListener('DOMContentLoaded', function() {
  // Mobile mega menu functionality
  const burgerMenuMobile = document.querySelector('.burger-menu--mobile');
  const menuMobile = document.getElementById('hero-main-mega-menu-mobile');
  const overlayMobile = document.getElementById('hero-main-mega-menu-mobile-overlay');
  const backBtn = document.getElementById('hero-main-mega-menu-mobile-back');
  const titleEl = document.getElementById('hero-main-mega-menu-mobile-title');
  const contentEl = document.getElementById('hero-main-mega-menu-mobile-content');
  let stack = [];

  // Global function to open mobile menu
  window.openMegaMenuMobile = function() {
    menuMobile.classList.add('open');
    overlayMobile.classList.add('open');
    document.body.style.overflow = 'hidden';
    stack = [];
    dissolveMenu('in');
    renderList(window.megaMenuData.concat(window.secondMenuData).concat(window.sidebarMenuData), 'Menu', null);
  };

  // Global function to close mobile menu
  window.closeMegaMenuMobile = function() {
    dissolveMenu('out');
    setTimeout(function() {
      menuMobile.classList.remove('open');
      overlayMobile.classList.remove('open');
      document.body.style.overflow = '';
    }, 150);
  };

  function dissolveMenu(direction, cb) {
    if (direction === 'in') {
      menuMobile.classList.add('dissolve-in');
      setTimeout(function() { 
        menuMobile.classList.remove('dissolve-in'); 
        if(cb) cb(); 
      }, 150);
    } else if (direction === 'out') {
      menuMobile.classList.add('dissolve-out');
      setTimeout(function() { 
        menuMobile.classList.remove('dissolve-out'); 
        if(cb) cb(); 
      }, 150);
    }
  }

  function animateContent(direction, cb) {
    contentEl.classList.remove('slide-in', 'slide-out', 'slide-in-reverse', 'slide-out-reverse');
    void contentEl.offsetWidth;
    if (direction === 'in') {
      contentEl.classList.add('slide-in');
      setTimeout(function() { 
        contentEl.classList.remove('slide-in'); 
        if(cb) cb(); 
      }, 350);
    } else if (direction === 'out') {
      contentEl.classList.add('slide-out');
      setTimeout(function() { 
        contentEl.classList.remove('slide-out'); 
        if(cb) cb(); 
      }, 350);
    } else if (direction === 'in-reverse') {
      contentEl.classList.add('slide-in-reverse');
      setTimeout(function() { 
        contentEl.classList.remove('slide-in-reverse'); 
        if(cb) cb(); 
      }, 350);
    } else if (direction === 'out-reverse') {
      contentEl.classList.add('slide-out-reverse');
      setTimeout(function() { 
        contentEl.classList.remove('slide-out-reverse'); 
        if(cb) cb(); 
      }, 350);
    }
  }

  function renderList(list, parentTitle, animate) {
    if (animate === 'in') animateContent('in');
    if (animate === 'out') animateContent('out');
    if (animate === 'in-reverse') animateContent('in-reverse');
    if (animate === 'out-reverse') animateContent('out-reverse');

    // Add "All" button logic
    var superCategoryHandle = stack.length > 0 ? stack[0].handle : null;
    if (
      list.length &&
      list[0] &&
      list[0].handle !== 'all-btn' &&
      list.every(function(item){return !item.links || item.links.length === 0;}) &&
      superCategoryHandle
    ) {
      var allText = {
        bg: 'Всички', cs: 'Vše', da: 'Alle', de: 'Alle', el: 'Όλα', en: 'All', es: 'Todo', fi: 'Kaikki', fr: 'Tout', hr: 'Sve', hu: 'Mind', it: 'Tutti', lt: 'Visi', nl: 'Alles', pl: 'Wszystko', 'pt-pt': 'Todos', ro: 'Toate', sk: 'Všetko', sl: 'Vse', sv: 'Alla'
      };
      var lang = (document.documentElement.lang || 'en').split('-')[0];
      var allBtnText = allText[lang] ? allText[lang] : allText['en'];
      var allBtnLabel = allBtnText + (parentTitle ? ' ' + parentTitle : '');
      var allBtnUrl = '';
      if (stack.length > 0 && stack[stack.length - 1] && stack[stack.length - 1].url) {
        allBtnUrl = stack[stack.length - 1].url;
      } else if (list[0] && list[0].url) {
        var urlParts = list[0].url.split('/');
        if (urlParts.length > 2) {
          allBtnUrl = '/' + urlParts[1] + '/' + urlParts[2];
        } else {
          allBtnUrl = list[0].url;
        }
      }
      list = [{
        handle: 'all-btn',
        title: allBtnLabel,
        url: allBtnUrl
      }].concat(list);
    }

    var html = '<ul class="hero-main-mega-menu-mobile__list">';
    var specialItemsHtml = [];
    var sidebarItemsHtml = [];

    list.forEach(function(item, idx) {
      var isStyle = item.style;
      var hasChildren = item.links && item.links.length > 0;
      var isLink = !hasChildren && !isStyle;
      var classes = 'hero-main-mega-menu-mobile__item';
      if (item.handle === 'all-btn') classes += ' hero-main-mega-menu-mobile__item--special hero-main-mega-menu-mobile__item--all';
      if (item.handle === 'news') classes += ' hero-main-mega-menu-mobile__item--news';
      if (item.handle === 'sale') classes += ' hero-main-mega-menu-mobile__item--sale';
      if (item.handle === 'extreme-outlet') classes += ' hero-main-mega-menu-mobile__item--extreme';
      if (item.handle === 'show-all') classes += ' hero-main-mega-menu-mobile__item--showall';
      if (isLink) classes += ' hero-main-mega-menu-mobile__item--link';

      html += '<li class="' + classes + '" data-handle="' + item.handle + '">';
      if (item.handle === 'all-btn') {
        html += '<a href="' + item.url + '" style="display:flex;align-items:center;justify-content:space-between;width:100%;color:inherit;text-decoration:none;box-sizing:border-box;white-space:normal;line-height:1.3;">';
        html += '<span>' + item.title + '</span>';
        html += '<svg style="transform:rotate(270deg);display:block;width:18px;height:18px;color:#ababab;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">';
        html += '<path d="M4 7L9 12L14 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
        html += '</svg>';
        html += '</a>';
      } else if (hasChildren || isStyle) {
        html += '<span style="display:flex;align-items:center;justify-content:space-between;width:100%;">';
        if (item.image) {
          html += '<img src="' + item.image + '" style="width:32px;height:32px;object-fit:cover;border-radius:0.3rem;flex-shrink:0;margin-right:1.2rem;">';
        }
        html += '<span>' + item.title + '</span>';
        html += '<span class="menu-arrow">'
          + '<svg style="transform:rotate(270deg);display:block;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">'
          + '<path d="M4 7L9 12L14 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
          + '</svg>'
        + '</span>';
        html += '</span>';
      } else {
        html += '<a href="' + item.url + '" style="display:flex;align-items:center;gap:0.7rem;width:100%;color:inherit;text-decoration:none;">';
        if (item.image) {
          html += '<img src="' + item.image + '" style="width:32px;height:32px;object-fit:cover;border-radius:0.3rem;flex-shrink:0;margin-right:1.2rem;">';
        } else if (item.icon) {
          html += '<span style="display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;min-width:24px;min-height:24px;margin-right:0.7rem;">';
          html += '<img src="' + item.icon + '" style="width:20px;height:20px;display:block;">';
          html += '</span>';
        } else if (item.handle === 'my-orders' || item.handle === 'account-settings' || item.handle === 'logout') {
          html += '<span style="display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;min-width:24px;min-height:24px;margin-right:0.7rem;">';
          if (item.handle === 'my-orders') {
            html += '📋';
          } else if (item.handle === 'account-settings') {
            html += '⚙️';
          } else if (item.handle === 'logout') {
            html += '🚪';
          }
          html += '</span>';
        }
        html += '<span>' + item.title + '</span>';
        html += '</a>';
      }
      html += '</li>';
    });


    html += '</ul>';
    
    if (specialItemsHtml.length) {
      html += '<div class="hero-main-mega-menu-mobile__special-list">' + specialItemsHtml.join('') + '</div>';
    }
    
    if (sidebarItemsHtml.length) {
      html += '<div class="hero-main-mega-menu-mobile__sidebar-list">';
      html += sidebarItemsHtml.join('');
      html += '</div>';
    }

    contentEl.innerHTML = html;

    titleEl.textContent = parentTitle || 'Menu';

    if (stack.length > 0) {
      backBtn.style.display = 'flex';
      titleEl.classList.add('clickable');
      titleEl.style.pointerEvents = 'auto';
      titleEl.onclick = function() { backBtn.onclick(); };
    } else {
      backBtn.style.display = 'none';
      titleEl.classList.remove('clickable');
      titleEl.style.pointerEvents = 'none';
      titleEl.onclick = null;
    }

    Array.from(contentEl.querySelectorAll('.hero-main-mega-menu-mobile__item')).forEach(function(el) {
      const item = list.find(i => i.handle === el.dataset.handle);
      if (item && item.links && item.links.length > 0) {
        el.onclick = function() {
          stack.push({list: list, title: parentTitle, handle: item.handle, url: item.url});
          if (item.style) {
            renderStyleGrid(item.links, item.title, 'in');
          } else {
            renderList(item.links, item.title, 'in');
          }
        };
      } else if (item && !item.style) {
        // For items without children (like "All" button), navigate to URL if available
        el.onclick = function() { 
          if (item.url && item.url !== '#') {
            window.location.href = item.url;
          }
          closeMegaMenuMobile(); 
        };
      }
    });

    // Handle special items (including "All" button)
    Array.from(contentEl.querySelectorAll('.hero-main-mega-menu-mobile__item--special')).forEach(function(el) {
      el.addEventListener('click', function(e) {
        if (e.target.tagName.toLowerCase() === 'a') return;
        var a = el.querySelector('a');
        if (a) {
          a.click();
        } else {
          closeMegaMenuMobile();
        }
      });
    });
  }

  function renderStyleGrid(list, parentTitle, animate) {
    if (animate === 'in') animateContent('in');
    if (animate === 'out') animateContent('out');
    if (animate === 'in-reverse') animateContent('in-reverse');
    if (animate === 'out-reverse') animateContent('out-reverse');

    var html = '<div class="hero-main-mega-menu-mobile__style-grid">';
    list.forEach(function(item, idx) {
      var hasChildren = item.links && item.links.length > 0;
      var itemClass = 'hero-main-mega-menu-mobile__style-item';
      if (hasChildren) itemClass += ' hero-main-mega-menu-mobile__style-item--has-children';
      
      if (hasChildren) {
        html += '<div class="' + itemClass + '" data-index="' + idx + '">';
      } else {
        html += '<a href="' + item.url + '" class="' + itemClass + '">';
      }
      
      if (item.image) {
        html += '<img class="hero-main-mega-menu-mobile__style-img" src="' + item.image + '" alt="' + item.title + '">';
      }
      html += '<div class="hero-main-mega-menu-mobile__style-title">' + item.title + '</div>';
      
      if (hasChildren) {
        html += '<svg style="position:absolute;bottom:8px;right:8px;width:16px;height:16px;color:#666;" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">';
        html += '<path d="M4 7L9 12L14 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" transform="rotate(-90 9 9)"/>';
        html += '</svg>';
        html += '</div>';
      } else {
        html += '</a>';
      }
    });
    html += '</div>';

    contentEl.innerHTML = html;
    titleEl.textContent = parentTitle;

    if (stack.length > 0) {
      backBtn.style.display = 'flex';
      titleEl.classList.add('clickable');
      titleEl.style.pointerEvents = 'auto';
      titleEl.onclick = function() { backBtn.onclick(); };
    } else {
      backBtn.style.display = 'none';
      titleEl.classList.remove('clickable');
      titleEl.style.pointerEvents = 'none';
      titleEl.onclick = null;
    }
    
    // Handle clicks on items with children
    Array.from(contentEl.querySelectorAll('.hero-main-mega-menu-mobile__style-item--has-children')).forEach(function(el) {
      var idx = parseInt(el.dataset.index);
      var item = list[idx];
      if (item && item.links && item.links.length > 0) {
        el.onclick = function() {
          stack.push({list: list, title: parentTitle, handle: item.handle, url: item.url, wasGrid: true});
          renderList(item.links, item.title, 'in');
        };
      }
    });
  }

  // Open menu on burger click
  if (burgerMenuMobile) {
    burgerMenuMobile.addEventListener('click', function() {
      openMegaMenuMobile();
    });
  }

  // Back button functionality
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      if (stack.length) {
        const prev = stack.pop();
        renderList(prev.list, prev.title, 'in-reverse');
      }
    });
  }

  // Close on overlay click
  if (overlayMobile) {
    overlayMobile.addEventListener('click', closeMegaMenuMobile);
  }
});

